import {Controller} from 'stimulus'
import {Logger} from "sass";

export default class extends Controller {
    static targets = [
        "startDatetimeField",
        "endDatetimeField",
        "messageIdField",
        "bookingSeriesSubmitButton",
        "bookingSeriesSlots",
        "bookAppointmentSubmitButton",
        "selectTimeContainer",
        "bookingSeriesList",
        "bookingQuestions",
        "displayBookingSlot"]

    connect() {
    }

    updateNextBooking(event) {
        this.bookingSeriesSubmitButtonTarget.dataset.bookingSeriesCount = (parseInt(this.bookingSeriesSubmitButtonTarget.dataset.bookingSeriesCount) - 1).toString();
        var bookingSeriesTotal = parseInt(this.bookingSeriesSubmitButtonTarget.dataset.bookingSeriesTotal);
        var bookingSeriesCount = parseInt(this.bookingSeriesSubmitButtonTarget.dataset.bookingSeriesCount);
        var selectedBookingSlotText = this.element.querySelector('.selected-booking-slot-text')

        let currentSlots = {};
        let nextSlotIndex = 0;

        if (this.bookingSeriesSlotsTarget.value) {
            try {
                currentSlots = JSON.parse(this.bookingSeriesSlotsTarget.value);

                // Determine the next available index
                const keys = Object.keys(currentSlots);
                if (keys.length > 0) {
                    const maxKey = Math.max(...keys.map(Number));
                    nextSlotIndex = maxKey + 1;
                }

            } catch (error) {
                console.error("error parsing json", error);
                currentSlots = {};
            }
        }

        // Add the new booking slot to the current slots object
        currentSlots[nextSlotIndex] = {
            startTime: this.startDatetimeFieldTarget.value,
            endTime: this.endDatetimeFieldTarget.value,
            displayTime: this.displayBookingSlotTarget.value
        };
        // Update the booking series selected data time value to the hidden field.
        this.bookingSeriesSlotsTarget.value = JSON.stringify(currentSlots);

        // Update the selected booking slot text
        selectedBookingSlotText.innerHTML = `For appointment ${(bookingSeriesTotal + 1) - bookingSeriesCount} of ${bookingSeriesTotal}, you selected:`

        // If the booking series list target exists, update the booking series booked state.
        if (this.hasBookingSeriesListTarget) {
            const bookedIcon = this.bookingSeriesListTarget.dataset.bookedIcon;
            const bookingIcon = this.bookingSeriesListTarget.dataset.selectingIcon;
            Object.entries(currentSlots).forEach(([key, value]) => {
                var bookingSeries = this.bookingSeriesListTarget.querySelector(`.booking-series-${parseInt(key) + 1}`);
                var nextBookingSeries = this.bookingSeriesListTarget.querySelector(`.booking-series-${parseInt(key) + 2}`);
                if (bookingSeries) {
                    bookingSeries.querySelector('.booking-series-list-content').innerHTML = value.displayTime;
                    bookingSeries.querySelector('.booking-series-icon').innerHTML = `<i class="${bookedIcon}"></i>`
                    var bookingSeriesList = Array.from(this.bookingSeriesListTarget.querySelectorAll('.booking-series-list'));
                    var indexInArray = bookingSeriesList.indexOf(bookingSeries);
                    if (indexInArray !== -1) {
                        bookingSeriesList.splice(indexInArray, 1);
                    }
                }
                if (nextBookingSeries){
                    nextBookingSeries.querySelector('.booking-series-list-content').innerHTML = `<span class="text-black">Select a day & time for appointment ${(bookingSeriesTotal + 1) - bookingSeriesCount} of ${bookingSeriesTotal}</span>`
                    nextBookingSeries.querySelector('.booking-series-icon').innerHTML = `<i class="${bookingIcon}"></i>`
                }
            })
        }

        if (bookingSeriesCount === 1) {
            this.bookAppointmentSubmitButtonTarget.classList.remove('hidden')
            this.bookingSeriesSubmitButtonTarget.classList.add('hidden')
        }
        if (bookingSeriesCount === 0) {
            this.selectTimeContainerTarget.classList.add('hidden');
        } else {
            this.selectTimeContainerTarget.classList.remove('hidden');
        }
    }


    updateBookingSelection(event) {
        // Update the currently booking this appointment state
        var selectable_time = event.target.closest(".selectable-time");
        this.displayBookingSlotTarget.value = selectable_time.dataset.displayBookingSlot;
        var booking_series_total = parseInt(this.bookingSeriesSubmitButtonTarget.dataset.bookingSeriesTotal);
        var booking_series_count = parseInt(this.bookingSeriesSubmitButtonTarget.dataset.bookingSeriesCount);
        var currentBookingCount = (booking_series_total + 1) - booking_series_count
        if (currentBookingCount !== 1) {
            this.bookingQuestionsTarget.classList.add('hidden');
        }
        const selectingStateIcon = this.bookingSeriesListTarget.dataset.selectingIcon;
        var bookingSeries = this.bookingSeriesListTarget.querySelector(`.booking-series-${currentBookingCount}`);
        bookingSeries.querySelector('.booking-series-icon').innerHTML = `<i class="${selectingStateIcon}"></i>`
    }
}
